import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-invoice",
  "use": "icon-invoice-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-invoice\"><path d=\"M6 3v2a2 2 0 0 0 1.85 1.995L8 7h8a2 2 0 0 0 1.995-1.85L18 5V3h1a2 2 0 0 1 2 2v15a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h1zm10 13H8a1 1 0 0 0-.117 1.993L8 18h8a1 1 0 0 0 0-2zm0-5H8a1 1 0 0 0-.117 1.993L8 13h8a1 1 0 0 0 0-2zm-1-9a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h6z\" fill=\"#A4B4D0\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol